export const contributionsList = [
  {
    id: '2NJ86136M6056880D',
    amount: '50.00',
    formattedAmount: '$50.00',
    currency_code: 'USD',
    photos: [],
    donor_name: 'Donor 1',
    formattedDate: 'Today',
    is_sharing_donor_info: true,
    color: 'blue',
  },
  {
    id: '7VN634244U632853N',
    amount: '10.00',
    formattedAmount: '$10.00',
    currency_code: 'USD',
    photos: [],
    donor_name: 'Donor 2',
    formattedDate: 'Today',
    is_sharing_donor_info: true,
    color: 'purple',
  },
  {
    id: '6PK83182C08205146',
    amount: '10.00',
    formattedAmount: '$10.00',
    currency_code: 'USD',
    photos: [],
    donor_name: 'Donor 3',
    formattedDate: 'Today',
    is_sharing_donor_info: true,
    color: 'purple',
  },
  {
    id: '71W71989MJ654750P',
    amount: '5.00',
    formattedAmount: '$5.00',
    currency_code: 'USD',
    photos: [],
    donor_name: 'Donor 4',
    formattedDate: 'Today',
    is_sharing_donor_info: true,
    color: 'yellow',
  },
  {
    id: '17918227PU815320Y',
    amount: '5.00',
    formattedAmount: '$5.00',
    currency_code: 'USD',
    photos: [],
    donor_name: 'Donor 5',
    formattedDate: 'Today',
    is_sharing_donor_info: true,
    color: 'yellow',
  },
];
